export default {
    crop: {
        title: 'Zuschneiden',
        cropSize: 'Grösse zuschneiden',
        zoom: 'Zoom',
        custom: 'Individuell',
        post: 'Post',
        square: 'Quadrat',
        landscape: 'Landschaft',
        story: 'Story',
        portrait: 'Porträt',
        carousel: 'Karussell',
        commonAspectRatio: 'Gängiges Bildseitenverhältnis',
    },
};
